import script from "./WhatYouNeed.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatYouNeed.vue?vue&type=script&setup=true&lang=js"

import "./WhatYouNeed.vue?vue&type=style&index=0&id=5f6db354&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6db354"]])

export default __exports__